import * as React from "react";
import Descriptions from "antd/es/descriptions";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { FormModel } from "./types";
import { roundTokens, truncate } from "./utils";
import { toUnits } from "thirdweb";


export interface PayDescriptionProps {
    formModel: FormModel;
}

export const PayDescription: React.FunctionComponent<PayDescriptionProps> = (props) => {
    const screenMap = useBreakpoint();

    return (
        <Descriptions
            title="Transfer Summary"
            bordered
            column={screenMap.xs ? 1 : 2}
            layout="horizontal"
            size="middle"
            className="PayDescription"
        >
            <Descriptions.Item label="Order ID" span={2}>
                {props.formModel.orderId}
            </Descriptions.Item>
            <Descriptions.Item label="From Chain">{props.formModel.fromChain}</Descriptions.Item>
            <Descriptions.Item label="To Chain">{props.formModel.toChain}</Descriptions.Item>
            <Descriptions.Item label="To Send">{roundTokens(toUnits(props.formModel.fromAmount, 18), 18, 3)} {props.formModel.token}</Descriptions.Item>
            <Descriptions.Item label="To Receive">
                {roundTokens(toUnits(props.formModel.toAmount, 18), 18, 3)} {props.formModel.token}
            </Descriptions.Item>
            <Descriptions.Item label="Your Wallet Address" span={2}>
                {truncate(props.formModel.recipient)}
            </Descriptions.Item>
        </Descriptions>
    );
};
